import React from "react";
import logoSrc from "@/assets/toclean-master.png";

/**
 * BrandLogo — ToClean master branding block (approved).
 *
 * Renders the approved raster master logo (transparent PNG) exactly as
 * provided by the brand owner. The asset embeds the standalone symbol
 * (circular arrow + leaf), the "ToClean" wordmark (with the arrow-leaf as
 * the "o" of "To") and the "WORLD · IN · ACTION" tagline as a single
 * composed unit — do NOT reconstruct these parts individually.
 *
 * The single source of truth for the artwork is:
 *   /app/frontend/src/assets/toclean-master.png
 * (tight-cropped: 1396×355 px, aspect ~3.93:1, transparent background)
 *
 * Sizing: pass Tailwind height utilities via `className` (e.g. `h-9`,
 * `h-10`, `h-12`). The image scales by height and preserves its aspect
 * ratio automatically. Do not force a `width`.
 */
export default function BrandLogo({
  className = "",
  // Kept for backward compatibility with legacy call sites; the master
  // asset must not have its colours altered, so this prop is ignored.
  // eslint-disable-next-line no-unused-vars
  arrowClassName,
  testid = "brand-logo",
}) {
  return (
    <img
      src={logoSrc}
      alt="ToClean · World · In · Action"
      draggable="false"
      data-testid={testid}
      className={`brand-logo select-none w-auto ${className}`}
      style={{ display: "block" }}
    />
  );
}
